import { useEffect } from 'react';
import { LoginForm } from '@/pages/auth/components/LoginForm';
import { AppLogo } from '@/components/shared/display/Logo';
import { FormattedText } from '@/components/uiKit/FormattedText';
import { analytics } from '@/analytics';

export const LoginPage = () => {
  useEffect(() => {
    analytics.page({
      name: 'Login',
      title: 'DataMind Dashboard 2.0 - Login',
    });
  }, []);

  return (
    <div className="flex flex-col h-full justify-center items-center px-4 xl:px-0">
      <div className="max-w-[26.25rem] bg-white xl:bg-transparent rounded-lg xl:rounded-none px-6 xl:px-0 py-12 xl:py-0">
        <div className="xl:hidden w-full mb-8 flex justify-center items-center">
          <AppLogo size="184px" />
        </div>

        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-semibold text-center xl:text-left w-full xl:w-auto">
            <div className="xl:hidden">
              <FormattedText label="auth.login.headingMobile" />
            </div>

            <div className="hidden xl:block">
              <FormattedText label="auth.login.heading" />
            </div>
          </h1>

          <div className="hidden xl:block ml-[-0.25rem] mt-[-2px]">
            <AppLogo size="164px" />
          </div>
        </div>

        <div className="pb-10 pt-2 xl:pt-6 text-center xl:text-left">
          <FormattedText label="auth.login.description" />
        </div>

        <LoginForm />
      </div>
    </div>
  );
};
